export interface SavedPick {
  id: string;
  gameSlug: string;
  gameName: string;
  numbers: number[];
  bonusNumbers: number[];
  label?: string;
  createdAt: string;
}

export interface CheckedResult {
  id: string;
  gameSlug: string;
  gameName: string;
  drawDate: string;
  userNumbers: number[];
  userBonusNumbers: number[];
  matchedNumbers: number[];
  matchedBonus: number[];
  checkedAt: string;
}

const PICKS_KEY = "usalotteryclub_picks";
const CHECKED_KEY = "usalotteryclub_checked";
const FAVORITES_KEY = "usalotteryclub_favorites";

export function getSavedPicks(): SavedPick[] {
  try {
    return JSON.parse(localStorage.getItem(PICKS_KEY) || "[]");
  } catch { return []; }
}

export function savePick(pick: SavedPick) {
  const picks = getSavedPicks();
  picks.unshift(pick);
  localStorage.setItem(PICKS_KEY, JSON.stringify(picks.slice(0, 100)));
}

export function deletePick(id: string) {
  const picks = getSavedPicks().filter(p => p.id !== id);
  localStorage.setItem(PICKS_KEY, JSON.stringify(picks));
}

export function getCheckedResults(): CheckedResult[] {
  try {
    return JSON.parse(localStorage.getItem(CHECKED_KEY) || "[]");
  } catch { return []; }
}

export function saveCheckedResult(result: CheckedResult) {
  const results = getCheckedResults();
  results.unshift(result);
  localStorage.setItem(CHECKED_KEY, JSON.stringify(results.slice(0, 100)));
}

export function getFavoriteGames(): string[] {
  try {
    return JSON.parse(localStorage.getItem(FAVORITES_KEY) || "[]");
  } catch { return []; }
}

export function toggleFavoriteGame(slug: string) {
  const favs = getFavoriteGames();
  const idx = favs.indexOf(slug);
  if (idx >= 0) favs.splice(idx, 1);
  else favs.push(slug);
  localStorage.setItem(FAVORITES_KEY, JSON.stringify(favs));
  return favs;
}
